import { render } from "./InvalidAddressWarning.vue?vue&type=template&id=3bc7f960&scoped=true"
import script from "./InvalidAddressWarning.vue?vue&type=script&lang=js"
export * from "./InvalidAddressWarning.vue?vue&type=script&lang=js"

import "./InvalidAddressWarning.vue?vue&type=style&index=0&id=3bc7f960&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc7f960"]])

export default __exports__